import { Component, Input } from '@angular/core';
import { Contractor } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-contractor-info',
  templateUrl: './contractor-info.component.html',
  styleUrls: ['./contractor-info.component.scss']
})
export class ContractorInfoComponent {
  @Input() contractor: Contractor = new Contractor();
  @Input() columns = 2;

  constructor() {}
}
